*<template>
  <div style="transition: width 0.2s;"
    class="fill-gray_9C overflow-x-hidden overflow-y-auto scrollbar-thin scrollbar-thumb-blue-800 scrollbar-track-blue-200"
    :class="{ 'w-16': collapsed, 'w-62': !collapsed, 'hidden-menu': collapsed }">
    <div class="mt-1 mb-4 grid grid-flow-col auto-cols-max overflow-hidden py-8 border-b-2" v-if="!collapsed">
      <img src="/images/allumer_logo.png">
    </div>

    <div class="w-full flex" :class="{ 'ml-2': !linkJustifyCenter, 'justify-center': linkJustifyCenter }"
      v-if="collapse">
      <svg class="mb-6 w-6 h-6 fill-gray_9C cursor-pointer float-right" xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20" @click.prevent="collapsedMenu = !collapsedMenu;">
        <path d="M0 3h20v2H0V3zm0 6h20v2H0V9zm0 6h20v2H0v-2z" />
      </svg>
    </div>

    <main-menu-item v-for="(route, index) in routes" :key="index" :label="route.label" :icon="route.icon"
      :link="route.link" :selected="$page.url == route.link" :method="route.method" :as="route.as"
      :action="route.action" :badge="route.badge" @logout="$emit('logout')" @invoke-action="handleRouteAction(route)" />

  </div>
</template>

<script>
import { Link } from '@inertiajs/inertia-vue3'
import Icon from '@/Shared/Icon'
import MainMenuItem from '@/Shared/MainMenuItem'
import { computed } from 'vue'
import { usePage } from '@inertiajs/inertia-vue3'

export default {
  components: {
    Icon,
    MainMenuItem,
    Link,
  },
  emits: ['logout', 'trigger-action'],
  props: {
    collapse: {
      type: Boolean,
      default: false,
    },

    routes: {
      type: Array,
      required: true,
    }
  },
  data() {
    return {
      collapsedMenu: false,
      linkJustifyCenter: false,
    }
  },
  computed: {
    collapsed: function () {
      return this.collapse && this.collapsedMenu;
    },
  },
  methods: {
    checkSelected(item) {
      if (item.link == '/') {
        return this.$page.url == '/';
      } else {
        return this.$page.url.startsWith(item.link);
      }
    },
    handleRouteAction(route) {
      if (!route || !route.action) {
        return
      }

      this.$emit('trigger-action', route.action)
    }
  },
  watch: {
    collapsedMenu(newValue) {
      localStorage.collapsedMenu = newValue;
      setTimeout(function () {
        this.linkJustifyCenter = this.collapsedMenu;
      }, 200);
    }
  },
  mounted() {
    if (typeof (localStorage.collapsedMenu) == "string") {
      this.collapsedMenu = JSON.parse(localStorage.collapsedMenu) === true;
    }
  },
  setup() {
    const user = computed(() => usePage().props.value.auth.user)
    return { user }
  },
}
</script>
<style>
.hidden-menu a,
.hidden-menu button {
  padding-left: 0;
  padding-right: 0;
  justify-content: center;
}

.hidden-menu a span,
.hidden-menu button span {
  display: none;
}

.hidden-menu a svg,
.hidden-menu button svg {
  margin-right: 0;
}
</style>
